import { generateBookHandler } from "./handlers/generate-book-handler";

export const taskExecutorMap = {
  "generate:book": generateBookHandler,
};
